import {
    PROFILES_LIST_URL
} from './constants';

import {
    getAxios,
    formDataToRequestParams
} from './axios'

export function getProfiles(data) {
    let axios = getAxios();

    return axios.get(
        PROFILES_LIST_URL, {
            params: data
        }
    );
}



// WEBPACK FOOTER //
// ./src/backend-helpers/profiles.js